import { render, staticRenderFns } from "./aiTool.vue?vue&type=template&id=461fcc57&scoped=true"
import script from "./aiTool.vue?vue&type=script&lang=js"
export * from "./aiTool.vue?vue&type=script&lang=js"
import style0 from "./aiTool.vue?vue&type=style&index=0&id=461fcc57&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461fcc57",
  null
  
)

export default component.exports